import { render, staticRenderFns } from "./setSplit.vue?vue&type=template&id=47eccdf7&scoped=true&"
import script from "./setSplit.vue?vue&type=script&lang=js&"
export * from "./setSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eccdf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47eccdf7')) {
      api.createRecord('47eccdf7', component.options)
    } else {
      api.reload('47eccdf7', component.options)
    }
    module.hot.accept("./setSplit.vue?vue&type=template&id=47eccdf7&scoped=true&", function () {
      api.rerender('47eccdf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setSplit.vue"
export default component.exports